"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RedemptionSection = void 0;
exports.default = RedemptionApp;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _redemptionForm = _interopRequireDefault(require("./redemption-form.js"));
var _productOffers = _interopRequireDefault(require("./product-offers.js"));
var _domainForm = _interopRequireDefault(require("./domain-form.js"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable max-statements */
/* eslint-disable complexity */

const RedemptionSection = exports.RedemptionSection = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "RedemptionSection",
  class: "pl-r10p0l6n",
  vars: {
    "r10p0l6n-1": [({
      tablet
    }) => tablet ? `url(${tablet})` : 'initial']
  }
});
const AddToCartContainer = /*#__PURE__*/(0, _react2.styled)("p")({
  name: "AddToCartContainer",
  class: "pl-awy7tle"
});
function getQueryString(key) {
  if (typeof window === 'undefined') return '';
  var qs = {};
  return qs[key];
}
const apiErrorResponse = {
  Success: false,
  Code: '',
  Status: 'ApiError'
};
function RedemptionApp({
  id,
  productIsWaiting,
  enterRedemptionCodePrompt,
  redemptionPlaceHolder,
  btnAddToCart,
  errorCodeNotEntered,
  errorCodeDidntWork,
  errorRedemptionCodeUsed,
  errorSubmittingInformation,
  errorValidDomainsInclude,
  codeVerified,
  chooseDomain,
  domainPlaceholder,
  btnSearch,
  congratulations,
  oneOfTheFollowing,
  orSeparator,
  btnSubmit,
  redemptionApiUrl,
  cartUrl,
  domainSearchUrl,
  redemptionApiResponseOverride,
  ...sectionProps
}) {
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [redemptionApiResponse, setRedemptionApiResponse] = (0, _react.useState)({});
  const [enteredCode, setEnteredCode] = (0, _react.useState)('');
  const redemptionApiResponseStati = {
    Blank: errorCodeNotEntered,
    Redeemed: errorRedemptionCodeUsed,
    Revoked: errorCodeDidntWork,
    Expired: errorCodeDidntWork,
    Invalid: errorCodeDidntWork,
    ApiError: errorSubmittingInformation,
    PendingActivation: errorCodeDidntWork
  };
  const addProductsToCart = () => {
    fetch(`${redemptionApiUrl}${enteredCode}?itc=slp_redeem&addtocart=true`).then(res => res.json()).then(() => {
      if (typeof window !== 'undefined') {
        window.location.hash = enteredCode;
        window.location.href = cartUrl;
      }
    }, () => {
      setIsLoading(false);
      setRedemptionApiResponse(apiErrorResponse);
    });
  };
  const getCodeInfo = code => {
    setRedemptionApiResponse(null);
    fetch(`${redemptionApiUrl}${code}`).then(res => res.json()).then(result => {
      setIsLoading(false);
      setRedemptionApiResponse(result);
    }, () => {
      setIsLoading(false);
      setRedemptionApiResponse(apiErrorResponse);
    });
  };
  (0, _react.useEffect)(() => {
    if (redemptionApiResponseOverride?.Code) {
      setRedemptionApiResponse(redemptionApiResponseOverride);
      setEnteredCode(redemptionApiResponseOverride.Code);
    }
    // Get initial Redemption Code from query
    const rcFromHash = typeof window === 'undefined' ? '' : (window.location.hash || '#').slice(1);
    const rcFromQuery = getQueryString('redemptioncode');
    const rcFromQueryShort = getQueryString('rc');
    const code = rcFromHash || rcFromQuery || rcFromQueryShort || '';
    const cleanedCode = code.trim().replace(/[^a-zA-Z0-9-]/gi, '__');
    if (cleanedCode) {
      setEnteredCode(cleanedCode);
    }
  }, []);
  const components = {
    headerMessage: null,
    redemptionForm: null,
    productOfferInfo: null,
    domainSearchOrAddToCart: null
  };
  let formToShow = 'enterCode';
  if (redemptionApiResponse?.Status) {
    if (redemptionApiResponse.Success) {
      if (redemptionApiResponse.HasDomain) {
        formToShow = 'enterDomain';
      } else {
        formToShow = 'continueToCart';
      }
    }
  }
  if (formToShow === 'enterCode') {
    components.headerMessage = /*#__PURE__*/_react.default.createElement(_index.default, {
      eyebrow: productIsWaiting,
      heading: enterRedemptionCodePrompt,
      eyebrowTag: "h1",
      headlineTag: "h2"
    });
    components.redemptionForm = /*#__PURE__*/_react.default.createElement(_redemptionForm.default, {
      id: id,
      errorText: redemptionApiResponseStati[redemptionApiResponse?.Status],
      isLoading: isLoading,
      submitText: btnSubmit,
      redemptionPlaceHolderText: redemptionPlaceHolder,
      enteredCode: enteredCode,
      setEnteredCode: setEnteredCode,
      handleOnSearch: rc => {
        if (rc) {
          setEnteredCode(rc);
          getCodeInfo(rc);
        } else {
          setRedemptionApiResponse({
            Success: false,
            Code: '',
            Status: 'Blank'
          });
        }
      }
    });
  } else {
    components.headerMessage = /*#__PURE__*/_react.default.createElement(_index.default, {
      eyebrow: productIsWaiting,
      heading: codeVerified,
      eyebrowTag: "h1",
      headlineTag: "h2",
      description: congratulations
    });
    components.productOfferInfo = /*#__PURE__*/_react.default.createElement(_productOffers.default, {
      orSeparator: orSeparator,
      oneOfTheFollowing: oneOfTheFollowing,
      products: redemptionApiResponse.Products
    });
    if (formToShow === 'enterDomain') {
      components.domainSearchOrAddToCart = /*#__PURE__*/_react.default.createElement(_domainForm.default, {
        id: id,
        domainSearchUrl: domainSearchUrl,
        domainPlaceholder: domainPlaceholder,
        ci: getQueryString('ci'),
        domainFromQuery: getQueryString('q'),
        btnSearch: btnSearch,
        chooseDomain: chooseDomain,
        errorValidDomainsInclude: errorValidDomainsInclude,
        handleOnSearch: url => {
          setIsLoading(true);
          if (typeof window !== 'undefined') {
            window.location.href = url;
          }
        },
        redemptionApiResponse: redemptionApiResponse
      });
    } else {
      components.domainSearchOrAddToCart = /*#__PURE__*/_react.default.createElement(AddToCartContainer, null, /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, {
        design: "primary",
        "data-cy": "continue-to-cart",
        disabled: isLoading,
        text: btnAddToCart,
        onClick: () => {
          setIsLoading(true);
          addProductsToCart();
        }
      }));
    }
  }
  return /*#__PURE__*/_react.default.createElement(RedemptionSection, (0, _extends2.default)({
    id: `redemption-app-${id}`,
    dataCy: "redemption-app"
  }, sectionProps), components.headerMessage, components.redemptionForm, components.productOfferInfo, components.domainSearchOrAddToCart);
}
RedemptionApp.propTypes = {
  _name: _propTypes.default.string,
  id: _propTypes.default.string,
  productIsWaiting: _propTypes.default.string,
  enterRedemptionCodePrompt: _propTypes.default.string,
  redemptionPlaceHolder: _propTypes.default.string,
  codeVerified: _propTypes.default.string,
  chooseDomain: _propTypes.default.string,
  domainPlaceholder: _propTypes.default.string,
  congratulations: _propTypes.default.string,
  oneOfTheFollowing: _propTypes.default.string,
  orSeparator: _propTypes.default.string,
  errorSubmittingInformation: _propTypes.default.string,
  loading: _propTypes.default.string,
  btnAddToCart: _propTypes.default.string,
  btnSearch: _propTypes.default.string,
  btnSubmit: _propTypes.default.string,
  errorCodeNotEntered: _propTypes.default.string,
  errorCodeDidntWork: _propTypes.default.string,
  errorRedemptionCodeUsed: _propTypes.default.string,
  errorValidDomainsInclude: _propTypes.default.string,
  redemptionApiUrl: _propTypes.default.string,
  cartUrl: _propTypes.default.string,
  domainSearchUrl: _propTypes.default.string,
  redemptionApiResponseOverride: _propTypes.default.object,
  ..._section.default.propTypes
};